import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm$post, _vm$post2, _vm$post3, _vm$post4, _vm$post5, _vm$post6;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cellar-detail"
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "cellar-detail-content"
  }, [_c("section", {
    staticClass: "hero-section"
  }, [_c("div", {
    staticClass: "hero-content"
  }, [_c("div", {
    staticClass: "hero-overlay"
  }, [_c("h1", [_vm._v(_vm._s((_vm$post = _vm.post) === null || _vm$post === void 0 ? void 0 : _vm$post.title))])]), _c("div", {
    staticClass: "hero-image"
  }, [(_vm$post2 = _vm.post) !== null && _vm$post2 !== void 0 && _vm$post2.mainImage ? _c("img", {
    attrs: {
      src: _vm.urlForImage((_vm$post3 = _vm.post) === null || _vm$post3 === void 0 ? void 0 : _vm$post3.mainImage).width(2000).url()
    }
  }) : _vm._e(), _c("div", {
    staticClass: "hero-image-title-overlay"
  }, [_c("h1", [_vm._v(_vm._s((_vm$post4 = _vm.post) === null || _vm$post4 === void 0 ? void 0 : _vm$post4.title))])])]), _c("div", {
    staticClass: "hero-text"
  }, [_c("p", {
    staticClass: "description"
  }, [_vm._v(" " + _vm._s((_vm$post5 = _vm.post) === null || _vm$post5 === void 0 ? void 0 : _vm$post5.description) + " ")])])])]), _c("div", {
    staticClass: "post-sections-container"
  }, [_c("PostSections", {
    attrs: {
      postSections: (_vm$post6 = _vm.post) === null || _vm$post6 === void 0 ? void 0 : _vm$post6.sections
    }
  })], 1), _c("section", {
    staticClass: "button-section"
  }, [_c("router-link", {
    attrs: {
      to: {
        name: "login"
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var href = _ref.href,
          route = _ref.route,
          navigate = _ref.navigate;
        return [_c("button", {
          staticClass: "button",
          on: {
            click: navigate
          }
        }, [_vm._v("Explore Clos & Monopole")])];
      }
    }])
  })], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };